import React from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import loginBg from "../../../../images/notFound.svg";

const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
};

const NotFoundPage = () => {
  return (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={24}>
        <div
          style={{
            ...styles.bgLogin,
            backgroundImage: `url(${loginBg})`,
            height: "80%",
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#3F3D56", fontSize: 24 }}>
            Looks like you are lost. How about going back to{" "}
            <Link to="/">Home</Link> again?
          </h1>
        </div>
      </Col>
    </Row>
  );
};

export default NotFoundPage;
